/* unplugin-vue-components disabled */import { render } from "./PopupPublish.vue?vue&type=template&id=434a7aee&ts=true"
import script from "./PopupPublish.vue?vue&type=script&lang=ts"
export * from "./PopupPublish.vue?vue&type=script&lang=ts"

import "./PopupPublish.vue?vue&type=style&index=0&id=434a7aee&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__